<template>
    <div class="elContent">
        <div class = "main-content">
            <slot/>
        </div>
        <div class="elContent-resize" @mousedown.stop="mouseDown"></div>
    </div>
</template>
<script setup>

const mouseDown = (e) => {
    // 记录初始x位置
    // let clientX = e.clientX;
    let dragDom = e.currentTarget.parentNode;
    let EloffsetTop = dragDom.offsetTop;
    let minHeight = 300;
    let maxHeight = document.body.clientHeight - EloffsetTop - 80;
    //获取所有class为 elButton
    const elButton = dragDom.getElementsByClassName("elButton");
    //遍历elButton获取高度
    let elButtonHeight = 0;
    let elButtonTB = 8;
    for (let s = 0; s < elButton.length; s++) {
        //获取dragDom下面的el-table 下面的 class为columnsSetting
        const columnsSetting = dragDom.getElementsByClassName("columnsSetting");
        //判断有没有columnsSetting
        if (columnsSetting.length > 0) {
            //把columnsSetting放在elButton的里面
            elButton[s].appendChild(columnsSetting[0]);
            //给elButton添加class元素为clearfix
            elButton[s].classList.add("clearfix");
        }
        elButtonHeight += elButton[s].offsetHeight + elButtonTB;
    }
     document.onmousemove = function (e) {
      e.preventDefault(); // 移动时禁用默认事件
        //计算高度
        let height = e.clientY - EloffsetTop-80;
        if (height < minHeight) {
            height = minHeight;
        }
        if (height > maxHeight) {
            height = maxHeight;
        }
        dragDom.style.height = height + 'px';
        let tableHeight = height;
        //让父级也同步高度
        // dragDom.parentNode.style.height = height + 16 + 'px';
         //判断有没有 pageContent
        if (dragDom.getElementsByClassName("pageContent").length > 0) {
            tableHeight = tableHeight - 42;
        }
        if (dragDom.getElementsByClassName("el-table").length > 0) {
            dragDom.getElementsByClassName("el-table")[0].style.height = tableHeight-16- elButtonHeight + 'px';
        }
        // dragDom下面的el-table高度为dragDom的高度减去el-table的margin-top和margin-bottom

        if (dragDom.getElementsByClassName("el-table__empty-text").length > 0) {
            dragDom.getElementsByClassName("el-table__empty-text")[0].style.height = tableHeight-16- elButtonHeight  - 33 + 'px';
        }
    };
    // 拉伸结束
     document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
    };
}
</script>
<style lang="scss">
.elContent{
    height: 100%;
    width: 100%;
}
.elContent-resize{
    position:relative;
    z-index: 22;
    width: 100%;
    height: 8px;
    margin-top:-8px;
    cursor: all-scroll;
    // background: #fff;
    border-bottom: 8px solid #fff;
    box-sizing: border-box;
}
</style>
